import React from 'react'

import {Button, ButtonProps, Theme} from '@mui/material'
import {makeStyles} from 'tss-react/mui'

type ChoiceButtonProps = {
  children: React.ReactNode
  extraclass?: string
  isSelected: boolean
} & Pick<ButtonProps, 'className' | 'onClick' | 'size'>

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    height: 'auto',
    minHeight: 36,
    marginBottom: theme.spacing(2),
    padding: theme.spacing(1.5),
    borderColor: theme.palette.other.border,
    borderRadius: 16,
    color: theme.palette.other.brandColors.primary,
    backgroundColor: theme.palette.other.brandColors.white,
    '&:hover': {
      boxShadow: '3px 3px 10px rgba(0, 0, 0, 0.12)',
      borderColor: theme.palette.tertiary.main,
      backgroundColor: 'transparent',
    },
  },
  selected: {
    borderColor: theme.palette.primary.light,
    backgroundColor: theme.palette.tertiary.main,
    '&:hover': {
      boxShadow: 'none',
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.tertiary.main,
    },
  },
  outlinedSizeLarge: {
    fontWeight: 400, // default: 500
    fontSize: '1rem', // default: 0.9375rem
  },
}))

const ChoiceButton = (props: ChoiceButtonProps): JSX.Element => {
  const {isSelected, extraclass, children, ...others} = props
  const {classes} = useStyles()

  return (
    <Button
      data-selected={isSelected ? true : undefined}
      variant={'outlined'}
      size={'large'}
      className={extraclass || undefined}
      classes={{
        root: classes.root,
        outlined: isSelected ? classes.selected : undefined,
        outlinedSizeLarge: classes.outlinedSizeLarge,
      }}
      fullWidth
      {...others}
    >
      {children}
    </Button>
  )
}

ChoiceButton.defaultProps = {
  extraclass: '',
}

export default ChoiceButton
